import React from "react";

import october_location from "./imgs/october_location.png";

const ContactUs = () => {
  return (
    <>
      <section className="bg-gray-100">
        <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:py-20 lg:px-8">
          <div className="max-w-2xl lg:max-w-4xl mx-auto text-center">
            <h2 className="text-3xl font-bold text-gray-900">فرع القاهرة</h2>
            <p className="w-[100px] h-[4px] rounded-sm bg-rose-600 absolute left-1/2 mt-3 transform -translate-x-1/2"></p>
          </div>
          <div className="mt-16 lg:mt-20">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="rounded-lg overflow-hidden">
                <img src={october_location} alt="location" />
              </div>
              <div>
                <div className="max-w-full mx-auto rounded-lg overflow-hidden">
                  <div className="px-6 py-4">
                    <h3 className="text-2xl font-bold text-gray-900">
                      عنواننا
                    </h3>
                    <p className="mt-1 text-gray-900 font-medium">
                      الحي ١١ - عمارة ١٤٣ - شقة ١٦ الدور التاني - اكتوبر -
                      الجيزة
                    </p>
                  </div>
                  <div className="border-t border-gray-200 px-6 py-4">
                    <h3 className="text-xl font-medium text-gray-900">
                      تواصل علي
                    </h3>
                    <p className="mt-1 text-gray-950 font-bold">
                      ايميل: mareycontracting@gmail.com
                    </p>
                    <p className="mt-1 text-gray-950 font-bold">
                      واتساب : 01145337673
                    </p>
                    <p className="mt-1 text-gray-950 font-bold">
                      جوال : 01095593610
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-gray-100">
        <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:py-20 lg:px-8">
          <div className="max-w-2xl lg:max-w-4xl mx-auto text-center">
            <h2 className="text-3xl font-extrabold text-gray-900">فرع قنا</h2>
            <p className="w-[100px] h-[4px] rounded-sm bg-rose-600 absolute left-1/2 mt-3 transform -translate-x-1/2"></p>
          </div>
          <div className="mt-16 lg:mt-20">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="rounded-lg overflow-hidden">
                <iframe
                  title="map"
                  src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3581.1901248260283!2d32.717413575413566!3d26.157936877105147!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjbCsDA5JzI4LjYiTiAzMsKwNDMnMTIuMCJF!5e0!3m2!1sen!2seg!4v1738910976957!5m2!1sen!2seg"
                  width="600"
                  height="450"
                  allowfullscreen=""
                  loading="lazy"
                  referrerpolicy="no-referrer-when-downgrade"></iframe>
              </div>
              <div>
                <div className="max-w-full mx-auto rounded-lg overflow-hidden">
                  <div className="px-6 py-4">
                    <h3 className="text-2xl font-bold text-gray-900">
                      عنواننا
                    </h3>
                    <p className="mt-1 text-xl text-gray-900 font-medium">
                      ٢٠ شارع مصطفي كامل - الدور الخامس - شقة ١٠  - بندر - قنا
                    </p>
                  </div>
                  <div className="border-t border-gray-200 px-6 py-4">
                    <h3 className="text-xl font-medium text-gray-900">
                      تواصل علي
                    </h3>
                    <p className="mt-1 text-gray-950 font-bold">
                      ايميل: mareycontracting@gmail.com
                    </p>
                    <p className="mt-1 text-gray-950 font-bold">
                      واتساب : 01145337673
                    </p>
                    <p className="mt-1 text-gray-950 font-bold">
                      جوال : 01095593610
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactUs;
